import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GET_ALLWORKHISTORY_BY_ID, CREATE_REQUEST, GET_ALL_ORDERS, GET_REQUESTS_BY_ID, UPDATE_REQUEST, CREATE_STAUS_WORKHISTORY, GET_WORKHISTORY_BY_ID, UPDATE_WORKHISTORY, CREATE_ATTACHEMNTS, GET_ALLATTACHMENTS_BY_ID, DELETE_ATTACHMENTS, UPDATE_ATTACHMENTS, GET_ALLSTATUSWORKHISTORY_BY_ID } from '../Queries/Orders';
import { client } from '..';
import { GET_EMPLOYEE_CLIENTS } from '../Queries/EmployeeClients';
import { setLoader } from './loaderSlice';

export const getAllWorkHistoryByID = createAsyncThunk(
  'timer/getAllWorkHistoryByID',
  async (emailId, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setLoader(true))
      const { data } = await client.mutate({
        mutation: GET_ALLWORKHISTORY_BY_ID,
        variables: { emailId },
      });

      const taskData = data.getAllWorkHistoryByID || [];

      if (!taskData) {
        console.warn('No work history found for email:', emailId);
        return rejectWithValue('No work history found.');
      }

      return data.getAllWorkHistoryByID;

    } catch (error) {
      console.error('Error fetching work history:', error);
      return rejectWithValue('Error fetching work history');
    }
    finally{
      dispatch(setLoader(false))
    }
  }
);

export const createRequestThunk = createAsyncThunk(
  'orders/createRequest',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_REQUEST,
        variables: payload
      });

      return data.createRequest;
    } catch (error) {
      console.error(error);
      return rejectWithValue('Failed to create request');
    }
  }
);

export const fetchAllOrdersThunk = createAsyncThunk(
  "orders/fetchAllOrders",
  async ({ page, pageSize, filter, isAllOrders, id }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true))
      const { data } = await client.query({
        query: GET_ALL_ORDERS,
        variables: { page, pageSize, filters: filter, isAllOrders, id },
        fetchPolicy: 'no-cache',
      });

      const orderData = data.getAllOrders;

      // No payload at all — a GraphQL error the client surfaced as `data` with
      // a null field, for instance. Reading `.response` off it would throw a
      // TypeError that reaches the user verbatim as the error text, so name it.
      if (!orderData) {
        return rejectWithValue('No response from the server. Please try again.');
      }

      // The resolver swallows its own errors and returns status 400 with an
      // empty response, which the grid used to render as an indistinguishable
      // "No data". Treat that as a failure so the user is told something went
      // wrong instead of being shown a silently empty list.
      if (orderData?.status && orderData.status !== 200) {
        console.error('getAllOrders returned status', orderData.status, orderData.message);
        return rejectWithValue(
          typeof orderData.message === 'string' && orderData.message
            ? orderData.message
            : 'Failed to load requests'
        );
      }

      return {
        response: orderData.response || [],
        summary: orderData.summary || {},
        TotalCount: orderData.totalRecords || 0, // Adjust key if needed
      };
    } catch (error) {
      console.error('Error in fetchAllOrders:', error);
      return rejectWithValue(error?.message || 'Failed to get all orders');
    }
    finally {
      dispatch(setLoader(false))
    }
  }
);

export const fetchEmployeeClientsThunk = createAsyncThunk(
  'clients/fetchEmployeeClients', async (userId, { rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: GET_EMPLOYEE_CLIENTS,
        variables: { id: userId },
        fetchPolicy: 'no-cache',
      })
      const clientList = data?.getEmployeeClients?.response[0]?.client || [];
      return clientList;
    }
    catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch employee clients');
    }
  }
);

export const fetchRequestByIdThunk = createAsyncThunk(
  'requests/fetchRequestById',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setLoader(true))
      const { data } = await client.mutate({
        mutation: GET_REQUESTS_BY_ID,
        variables: { id },
        fetchPolicy: 'no-cache',
      });

      const RequestInfo = data?.getRequestById?.[0];
      if (!RequestInfo) throw new Error('Request not found');
      return RequestInfo; // send to component
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch request');
    }
    finally{
      dispatch(setLoader(false))
    }
  }
);

export const updateRequestThunk = createAsyncThunk(
  'requests/updateRequest', async ({ valuesObject, historyObject }, { dispatch, rejectWithValue }) => {
    try {
      await client.mutate({
        mutation: CREATE_STAUS_WORKHISTORY,
        variables: historyObject
      })
      const { data } = await client.mutate({
        mutation: UPDATE_REQUEST,
        variables: valuesObject
      })
      
      return data.updateRequest
    }
    catch (err) {
      return rejectWithValue(err.message || 'Failed to update request');
    }
  }
);

export const getWorkHistoryByIdThunk = createAsyncThunk(
  "workHistory/getById",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: GET_WORKHISTORY_BY_ID,
        variables: { userId },
        fetchPolicy: "no-cache",
      });

      const workHistoryList = data?.getWorkHistoryID || [];

      return workHistoryList;
    } catch (error) {
      console.error("Error fetching work history by ID:", error);
      return rejectWithValue(
        error?.message || "Failed to fetch work history"
      );
    }
  }
);

export const updateWorkHistoryThunk = createAsyncThunk(
  "workHistory/update",
  async (workHistoryPayload, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_WORKHISTORY,
        variables: workHistoryPayload,
        fetchPolicy: "no-cache",
      });

      return data?.updateWorkHistory;
    } catch (error) {
      console.error("Error updating work history:", error);
      return rejectWithValue(error?.message || "Failed to update work history");
    }
  }
);
export const fetchAttachmentsByIdAsync = createAsyncThunk(
  'attachments/fetchAttachmentsById',
  async (emailId, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setLoader(true))
      const { data } = await client.mutate({
        mutation: GET_ALLATTACHMENTS_BY_ID,
        variables: { emailId },
        fetchPolicy: 'no-cache',
      });
      return data?.getAllAttachmentsByID;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch attachments');
    }
    finally{
      dispatch(setLoader(false))
    }
  }
);
export const createAttachmentsAsync = createAsyncThunk(
  'attachments/create', async (valuesObject, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_ATTACHEMNTS,
        variables: valuesObject
      })
      return data.createAttachments
    }
    catch (error) {
      console.error("Error create Attachments:", error);
      return rejectWithValue(error?.message || "Failed to update work history");
    }
  })
export const deleteAttachmentAsync = createAsyncThunk(
  'attachments/delete',
  async (valuesObject, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_ATTACHMENTS,
        variables: valuesObject,
      });

      return data?.deleteAttachments;
    } catch (error) {
      console.error('Failed to delete attachment:', error);
      return rejectWithValue(error.message || 'Delete failed');
    }
  }
);
export const updateAttachmentAsync = createAsyncThunk(
  'attachments/delete',
  async (valuesObject, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_ATTACHMENTS,
        variables: valuesObject,
      });

      return data?.updateAttachments;
    } catch (error) {
      console.error('Failed to delete attachment:', error);
      return rejectWithValue(error.message || 'Delete failed');
    }
  }
);

export const fetcAllStatuWorkHistoryByIdAsync = createAsyncThunk(
  'request/statusWorkHistory', async (emailId, { rejectWithValue,dispatch }) => {
    try {
      dispatch(setLoader(true))
      const { data } = await client.mutate({
        mutation: GET_ALLSTATUSWORKHISTORY_BY_ID,
        variables: emailId,
        fetchPolicy: "network-only"
      })
      return data.getAllStatusWorkHistoryByID
    }
    catch (error) {
      console.error('Failed to delete attachment:', error)
      return rejectWithValue(error.message || 'workhistory failed')
    }
    finally{
      dispatch(setLoader(false))
    }
  }
)
const initialState = {
  orders: [],
  order: {},
  singleOrder: {},
  summary: {},
  TotalCount: 0,
  requestInfo: [],
  requestDetails: [],
  refreshPage: null,
  getAllClients: [],
  workHistoryDetail: [],
  statusWorkHistoryDetail: [],
  loading: false,
  attachmentsHistory: [],
  attachmentworkhistory: [],
  latestOrdersRequestId: null,
};
const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    submitRefreshPage: (state, action) => {
      state.refreshPage = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllWorkHistoryByID.fulfilled, (state, action) => {
        state.workHistoryDetail = action.payload;
      })
      .addCase(createRequestThunk.fulfilled, (state, action) => {
        state.order = action.payload;
        state.orders = [action.payload, ...state.orders];
      })
      .addCase(fetchAllOrdersThunk.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        // Track the most recently *dispatched* request. Multiple fetches can be
        // in flight at once (fast filter changes, refresh, pagination), and
        // network responses aren't guaranteed to arrive in the order they were
        // sent - without this, an older response landing after a newer one
        // would overwrite it, making the grid intermittently show stale/
        // unfiltered results.
        state.latestOrdersRequestId = action.meta.requestId;
      })
      .addCase(fetchAllOrdersThunk.fulfilled, (state, action) => {
        // Ignore responses from any request that isn't the latest one dispatched.
        if (action.meta.requestId !== state.latestOrdersRequestId) return;
        const { response, summary, TotalCount } = action.payload;
        state.orders = response;
        state.summary = summary;
        state.TotalCount = TotalCount;
        state.loading = false;
        state.refreshStatus = false;
      })
      // Without this case a failed fetch left `loading` true forever: the
      // refresh icon spun forever and the grid stayed empty with nothing
      // telling the user anything had gone wrong. Every failure must clear
      // the spinner AND surface a message.
      .addCase(fetchAllOrdersThunk.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestOrdersRequestId) return;
        state.loading = false;
        state.refreshStatus = false;
        state.error =
          (typeof action.payload === 'string' && action.payload) ||
          action.error?.message ||
          'Failed to load requests';
      })
      .addCase(fetchEmployeeClientsThunk.fulfilled, (state, action) => {
        state.getAllClients = action.payload
      })
      .addCase(fetchRequestByIdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRequestByIdThunk.fulfilled, (state, action) => {
        state.singleOrder = action.payload;
        state.loading = false
      })
      .addCase(updateRequestThunk.fulfilled, (state, action) => {
        state.orders = state.orders.map((order) =>
          order.id === action.payload.id ? action.payload : order
        );
      })
      .addCase(fetchAttachmentsByIdAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.attachmentsHistory = action.payload;

        const allHistory = action.payload?.flatMap((employee) =>
          Array.isArray(employee?.attachmentHistory) ? employee.attachmentHistory : []
        );
        state.attachmentworkhistory = allHistory;
      })
      .addCase(fetcAllStatuWorkHistoryByIdAsync.fulfilled, (state, action) => {
        state.statusWorkHistoryDetail = action.payload
      })
  },
});

export const { submitRefreshPage } = ordersSlice.actions;

export default ordersSlice.reducer;
